import get from 'lodash.get';

const getFingerprintApiKey = (rootState) =>
  get(rootState, 'config.common.fingerprint.public_api_key', null);

export default getFingerprintApiKey;
